var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45696_251509)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.8789 64.9609C50.552 64.9609 64.8789 50.6341 64.8789 32.9609C64.8789 15.2878 50.552 0.960938 32.8789 0.960938C15.2058 0.960938 0.878906 15.2878 0.878906 32.9609C0.878906 50.6341 15.2058 64.9609 32.8789 64.9609Z",
    fill: "#E50B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6791 16.9609L28.0791 18.5609H21.6791C20.7959 18.5609 20.0791 19.2777 20.0791 20.1609C20.0791 21.0441 20.7959 21.7609 21.6791 21.7609H24.8791H40.8791H44.0791C44.9623 21.7609 45.6791 21.0441 45.6791 20.1609C45.6791 19.2777 44.9623 18.5609 44.0791 18.5609H37.6791L36.0791 16.9609H29.6791ZM21.6791 24.9609V45.7609C21.6791 47.5289 23.1111 48.9609 24.8791 48.9609H40.8791C42.6471 48.9609 44.0791 47.5289 44.0791 45.7609V24.9609H21.6791Z",
    fill: "#E50B20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45696_251509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.878906 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinIcon);
export default __webpack_public_path__ + "static/media/delete-bin-icon.ce1698e0e8fad0339097f8ac98e6bd33.svg";
export { ForwardRef as ReactComponent };